<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <g fill="currentColor" fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd">
      <path
        d="M10.4081 2.5917a5.9167 5.9167 0 1 0 3.5086 5.4079v-.613a.75.75 0 0 1 1.5 0V8a7.4168 7.4168 0 0 1-13.6386 4.0329 7.4166 7.4166 0 0 1 9.2405-10.8113.75.75 0 0 1 .3798.9903.75.75 0 0 1-.9903.3798Z"
      />
      <path
        d="M15.1967 2.136a.75.75 0 0 1 .0006 1.0607L8.5306 9.8701a.7503.7503 0 0 1-1.061.0002l-2-2a.75.75 0 1 1 1.0607-1.0606L7.9997 8.279l6.1364-6.1425a.75.75 0 0 1 1.0606-.0005Z"
      />
    </g>
    <defs>
      <clipPath id="a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath>
    </defs>
  </svg>
</template>
